import React from "react";
import PropTypes from "prop-types";
import {
  Table,
  Divider,
  Input,
  Button,
  Tooltip,
  Select,
  Popconfirm,
} from "antd";
import {
  SearchOutlined,
  PlusCircleOutlined,
  EditOutlined,
  FileTextOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import {
  defaultSort,
  getTablePagesize,
  selectFilterFunction,
  setTablePageSize,
} from "../../../Constants/Utilities";
import { StatusSwitch } from "../../Common/StatusSwitch";
import {
  ConfigActions,
  EntityStatus,
  StatusFilters,
  TablePages,
  TablePageSizes,
} from "../../../Constants/Constants";
import { BreadCrumbs } from "../../Common/BreadCrumbs";

class ListServiceConfig extends React.Component {
  constructor(props) {
    super(props);
    console.log("ListServiceConfig props", props);
    this.state = {
      serviceConfigData: props.serviceConfigData,
    };
  }

  componentDidUpdate(prevProps) {
    const { serviceData, serviceConfigData } = this.props;
    if (
      prevProps.serviceData !== serviceData ||
      prevProps.serviceConfigData !== serviceConfigData
    ) {
      this.setState({ serviceData, serviceConfigData });
    }
  }

  getColumns = () => [
    {
      title: "Configuration Name",
      dataIndex: "name",
      sorter: (a, b) => defaultSort(a.name, b.name),
      defaultSortOrder: "ascend",
      render: (value, record) => (
        <Button
          type="link"
          onClick={this.props.onActionClick(ConfigActions.view, record)}
        >
          {value}
        </Button>
      ),
    },
    {
      title: "Active",
      dataIndex: "status",
      align: "center",
      filters: StatusFilters,
      onFilter: (value, record) => record.status === value,
      render: StatusSwitch(this.props.onStatusChange),
    },
    {
      title: "Actions",
      dataIndex: "actions",
      align: "center",
      render: (_, record) => (
        <div className="entity-list-actions">
          <Tooltip title="View Config">
            <FileTextOutlined
              className="entity-action"
              onClick={this.props.onActionClick(ConfigActions.view, record)}
            />
          </Tooltip>
          <Tooltip title="Edit Config">
            <EditOutlined
              onClick={this.props.onActionClick(ConfigActions.edit, record)}
            />
            {record.status === EntityStatus.INACTIVE && (
              <Tooltip title="Delete Config">
                <Popconfirm
                  okText="Yes"
                  cancelText="No"
                  title="Are you sure want to Delete Config?"
                  onConfirm={() => this.props.deleteServiceConfig(record)}
                >
                  <DeleteOutlined />
                </Popconfirm>
              </Tooltip>
            )}
          </Tooltip>
        </div>
      ),
    },
  ];

  onSerchTextChange = (e) => {
    const text = e.target.value;
    const { serviceConfigData } = this.props;
    if (!!text) {
      const filteredData = serviceConfigData.filter((item) =>
        item.name.toLowerCase().includes(text.toLowerCase())
      );
      this.setState({ serviceConfigData: filteredData });
      return;
    }
    this.setState({ serviceConfigData });
  };

  render() {
    const { serviceConfigData } = this.state;
    const {
      serviceData,
      serviceDataLoading,
      onActionClick,
      selectedService,
      onServiceSelect,
      serviceConfigDataLoading,
      deleteConfigLoading,
      parentBread,
    } = this.props;

    return (
      <div className="entity-list-container">
        <div className="page-header-container">
          <BreadCrumbs headers={parentBread} />
        </div>
        <Divider className="divider" />
        <div className="entity-selection-container">
          <span className="entity-label">Service:</span>
          <Select
            showSearch
            allowClear
            value={selectedService}
            loading={serviceDataLoading}
            disabled={serviceDataLoading}
            onChange={onServiceSelect}
            filterOption={selectFilterFunction}
            style={{ minWidth: "250px", maxWidth: "300px" }}
            placeholder={
              serviceDataLoading ? "Loading Services..." : "Select Service"
            }
          >
            {serviceData?.map((item) => (
              <Select.Option key={item.serviceId} title={item.serviceName}>
                {item.serviceName}
              </Select.Option>
            ))}
          </Select>
        </div>
        <Divider className="divider" />
        <div className="search-add-container">
          <div className="search-container">
            <span className="search-label">Search:</span>
            <Input
              allowClear
              className="search-input"
              placeholder="Enter Config Name"
              onChange={this.onSerchTextChange}
              disabled={!selectedService}
              suffix={<SearchOutlined style={{ fontSize: 16 }} />}
            />
          </div>
          <div className="add-container">
            <Button
              type="primary"
              icon={<PlusCircleOutlined />}
              onClick={onActionClick(ConfigActions.add, null)}
            >
              Add Configuration
            </Button>
          </div>
        </div>
        {!selectedService ? (
          <div className="no-entity-warning">
            <div className="warning-label">
              Select any Service to view configurations
            </div>
          </div>
        ) : (
          <Table
            bordered
            size="small"
            columns={this.getColumns()}
            className="entity-table"
            loading={
              serviceConfigDataLoading ||
              (deleteConfigLoading && {
                tip: "Fetching Configurations...",
              })
            }
            dataSource={serviceConfigData}
            pagination={{
              responsive: true,
              showQuickJumper: true,
              showSizeChanger: true,
              defaultPageSize: getTablePagesize(TablePages.listServiceConfig),
              pageSizeOptions: TablePageSizes,
              onChange: (_, pageSize) =>
                setTablePageSize(TablePages.listServiceConfig, pageSize),
            }}
          />
        )}
      </div>
    );
  }
}

ListServiceConfig.propTypes = {
  serviceData: PropTypes.array,
  serviceDataLoading: PropTypes.bool,
  selectedService: PropTypes.string,
  serviceConfigData: PropTypes.array,
  serviceConfigDataLoading: PropTypes.bool,
  deleteConfigLoading: PropTypes.bool,
  onServiceSelect: PropTypes.func,
  onActionClick: PropTypes.func,
  onStatusChange: PropTypes.func,
};

export default ListServiceConfig;
